import { __decorate, __metadata } from "tslib";
import { SingletonService } from '@trp-dms-digital-shared/ds-ui-library-common';
import { Subject } from 'rxjs';
let PredictiveSearchService = class PredictiveSearchService {
    apiSubject = new Subject();
    // Using base URL that is relative to the current domain to avoid CORS for lower environments
    baseUrl = window.location.host.indexOf('localhost:4400') !== -1
        ? 'https://www.troweprice.com/aem-services/trp/fai/subscription/query'
        : '/aem-services/trp/fai/subscription/query';
    constructor() {
        // This is intentional
    }
    fetchData(inputValue) {
        // Escape Regex special characters to avoid XSS
        const queryString = new URLSearchParams({
            product: inputValue.replace(/([.*+?^=!:{}()$|\]\\])/g, '\\$1'),
        }).toString();
        fetch(`${this.baseUrl}?${queryString}`)
            .then((response) => response.json())
            .then((data) => {
            this.apiSubject.next(data);
        })
            .catch((error) => {
            console.error('There was a problem fetching the data:', error);
            this.apiSubject.next(null);
        });
    }
    fetch() {
        return this.apiSubject.asObservable();
    }
};
PredictiveSearchService = __decorate([
    SingletonService,
    __metadata("design:paramtypes", [])
], PredictiveSearchService);
export { PredictiveSearchService };
//# sourceMappingURL=api-search.service.js.map